function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

export var getHourSectionOptions = function getHourSectionOptions(_ref) {
  var now = _ref.now,
      value = _ref.value,
      utils = _ref.utils,
      ampm = _ref.ampm,
      isDisabled = _ref.isDisabled,
      resolveAriaLabel = _ref.resolveAriaLabel,
      timeStep = _ref.timeStep;
  var currentHours = value ? utils.getHours(value) : null;
  var result = [];

  var isSelected = function isSelected(hour) {
    if (currentHours === null) {
      return false;
    }

    if (ampm) {
      if (hour === 12) {
        return currentHours === 12 || currentHours === 0;
      }

      return currentHours === hour || currentHours - 12 === hour;
    }

    return currentHours === hour;
  };

  var endHour = ampm ? 11 : 23;

  for (var hour = 0; hour <= endHour; hour += timeStep) {
    var label = utils.format(utils.setHours(now, hour), ampm ? 'hours12h' : 'hours24h');
    var ariaLabel = resolveAriaLabel(parseInt(label, 10).toString());
    label = utils.formatNumber(label);
    result.push({
      value: hour,
      label: label,
      isSelected: isSelected,
      isDisabled: isDisabled,
      ariaLabel: ariaLabel
    });
  }

  return result;
};
export var getTimeSectionOptions = function getTimeSectionOptions(_ref2) {
  var value = _ref2.value,
      isDisabled = _ref2.isDisabled,
      timeStep = _ref2.timeStep,
      resolveLabel = _ref2.resolveLabel,
      resolveAriaLabel = _ref2.resolveAriaLabel,
      _ref2$hasValue = _ref2.hasValue,
      hasValue = _ref2$hasValue === void 0 ? true : _ref2$hasValue;

  var isSelected = function isSelected(timeValue) {
    if (value === null) {
      return false;
    }

    return hasValue && value === timeValue;
  };

  return _toConsumableArray(Array.from({
    length: Math.ceil(60 / timeStep)
  }, function (_, index) {
    var timeValue = timeStep * index;
    return {
      value: timeValue,
      label: resolveLabel(timeValue),
      isDisabled: isDisabled,
      isSelected: isSelected,
      ariaLabel: resolveAriaLabel(timeValue.toString())
    };
  }));
};